import React from 'react';

import InputCost from '../../widgets/input-cost';
import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import FormActions from '../../../../shared/actions/form';
import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';
import { OptionList } from '../input-groups/select-menu';

import ModalWindowComponent from '../../../../../../../common/react/components/modal';
import { formatValueToLocale } from '../../../../shared/utilities';

export default class SaleItemElement extends React.Component {
	constructor(props) {
		super(props);

		let {
			cost,
			minQuantity,
			maxQuantity,
			required,
			stock,
			imageUrl,
			imageAlt,
			optionsLabel,
			options
		} = this.props.data;

		this.state = {
			cost: cost,
			min: minQuantity,
			max: maxQuantity,
			required: required,
			stock: stock,
			imageUrl: imageUrl,
			imageAlt: imageAlt,
			variationsLabel: optionsLabel,
			options: options,
			defaultPublicCheck: (minQuantity == 1 || minQuantity == 0) && maxQuantity == 1,
			showPreviewQtyBox: !((minQuantity == 1 || minQuantity == 0) && maxQuantity == 1),
			showAltTextModal : false
		};
	}

	updateImageState = (imageUrl) => {
		this.setState({
			imageUrl : imageUrl
		});
	};

	addImage = (ref) => {
		this.refs.uploader.classList.add('show');
	    this.refs.uploader.classList.remove('hidden');
	    this.refs.addImage.classList.toggle('hidden');
	};

	addVariations = () => {

		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		if (!this.state.options.length) {
			FormActions.initializeSelectMenu(fieldsetIndex, rowIndex, index);
		}

		this.refs.variations.classList.toggle('hidden');
		this.refs.addVariations.classList.toggle('hidden');
	};

	updateCost = (newCost) => {
		if (isNaN(newCost)) {
			return;
		}
		if (newCost == "") {
			newCost = "0.00";
		}

		this.setState({
			cost : newCost
		});
	};

	updateStock = (newStock) => {
		this.setState({
			stock : newStock
		});
	};

	handleKeyPress = (e) => {
		const invalidChars = ["-", "+", "e"];

		if (invalidChars.includes(e.key)) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	handleBoundsChange = (newValue, ref) => {
		// Prevent negative bound values
		if (newValue < 0) {
			alert("Value cannot be negative.");
			return;
		}

		if (ref == "min") {
			this.setState({
				min: newValue
			});

		} else if (ref == "max") {
			this.setState({
				max: newValue
			});
		}
	};

	handleBoundsBlur = (newValue, ref) => {
		const rawValue = newValue;
		// Round bound down to nearest integer
		newValue = Math.floor(newValue);

		if (ref == "min") {
			// Min should not be blank
			if (!newValue) { newValue = 0; }

			// Check that new min is < max
			if (newValue && this.state.max && newValue > this.state.max) {
				this.setState({
					min: this.state.max
				}, () => {
					alert("Min must be less than max");
					this.updateQuantityInputType();
				});
			} else {
				this.setState({
					min: newValue.toString()
				}, () => {
					this.updateQuantityInputType();
				});
			}

		} else if (ref == "max") {
			// Max should not be < 1
			if (rawValue == "0") { newValue = 1; }

			// Check that new max is > min
			if (rawValue != "" && newValue >= 0 && this.state.min && newValue < this.state.min) {
				this.setState({
					max: this.state.min
				}, () => {
					alert("Max must be more than min");
					this.updateQuantityInputType();
				});
			} else {
				this.setState({
					max: rawValue != "" ? newValue.toString() : ""
				}, () => {
					this.updateQuantityInputType();
				});
			}
		}
	};

	/*
	updateQuantityInputType fulfills a product request to display a specific quantity input type in the row preview
	based on the min/max values on an item row. The four (4) input states described below are all requested by product
	and are reflected on the public view of the form as well (though that code does not call this function).
	*/
	updateQuantityInputType = () => {
		// Determine min and max
		const min = this.state.min;
		const max = this.state.max;

		// Decide state of item's req. checkbox
		const itemRequiredCheckbox = document.getElementById(this.props.data.uniqueId + "_required_checkbox");
		itemRequiredCheckbox.checked = min > 0 || (min == "0" && max == "0");

		// OPEN CHECKBOX
		if (min == "0" && max == "1") {
			this.setState({
				defaultPublicCheck: true,
				showPreviewQtyBox: false,
				required: false
			}, () => {
				this.refs.publicRequiredBox.checked = false;
			});

		// DISABLED CHECKED CHECKBOX
		} else if (min == "1" && max == "1") {
			this.setState({
				defaultPublicCheck: true,
				showPreviewQtyBox: false,
				required: true
			}, () => {
				this.refs.publicRequiredBox.checked = true;
			});

		// DISABLED FIXED INPUT
		} else if (min == max) {
			this.setState({
				defaultPublicCheck: false,
				showPreviewQtyBox: true,
				required: true
			}, () => {
				this.refs.publicRequiredBox.checked = true;
			});

		// OPEN INPUT
		} else {
			this.setState({
				defaultPublicCheck: false,
				showPreviewQtyBox: true,
				required: min > 0
			}, () => {
				if (min > 0) {
					this.refs.publicRequiredBox.checked = true;
				} else {
					this.refs.publicRequiredBox.checked = false;
				}
			});
		}
	};

	addAltText = () => {
		this.setState({
			showAltTextModal: true
		})
	};

	hideModal = () => {
		this.setState({
			showAltTextModal: false
		})
	};

	saveAltText = (altText) => {
		if (typeof altText !== 'string') {
			altText = document.getElementById("alternate-text-container").value;
		}

		var newState = {
			imageAlt: altText
		};

		if (this.state.showAltTextModal === true) {
			newState["showAltTextModal"] = false;
		}

		this.setState(newState)
	};

	removeImage = () => {
		this.updateImageState('');

		const uploader = this.refs.uploader;
		uploader.classList.add('hidden');
		uploader.querySelector('#input_file').value = null;
		uploader.files = [];
	};

	removeUploader = () => {
		this.refs.uploader.classList.toggle('hidden');
		this.refs.addImage.classList.toggle('hidden');
	};

	componentDidMount() {
		let self = this;
		let uploader = this.refs.uploader;

		if (uploader) {
			uploader.addEventListener('change', function (evt) {
				var event =  evt || {};
				var selectedFiles = Array.isArray(event.detail) ? event.detail : [];
				var lastSelectedFile = selectedFiles[selectedFiles.length - 1] || { name: "" };

				function getImageAlt() {
					if (self.props.data.label.length && self.props.data.label != self.props.data.placeholder) {
						return self.props.data.label;
					}
					
					return lastSelectedFile.name || "";
				}

				self.saveAltText(getImageAlt());
				self.updateImageState(lastSelectedFile.sourceUrl || "");
				self.refs.uploader.classList.remove('show');
			});
		}

		let requiredCheckbox = document.getElementById(this.props.data.uniqueId + "_required_checkbox");

		if (parseInt(this.state.min) > 0) {
			requiredCheckbox.checked = true;
		}

		requiredCheckbox.addEventListener("change", (evt) => {
			let intMin = parseInt(this.state.min);
			let intMax = this.state.max ? parseInt(this.state.max) : "";

			if (evt.target.checked) {
				this.setState({
					min: this.state.min === "0" || !this.state.min ? "1" : this.state.min
				}, () => {
					if (this.state.min === "1" && this.state.min === this.state.max) {
						this.setState({
							defaultPublicCheck : true,
							showPreviewQtyBox: false,
							required: true
						});
						this.refs.publicRequiredBox.checked = true;
					} else {
						this.setState({
							defaultPublicCheck : false,
							showPreviewQtyBox : true,
							required: this.state.min > 0
						});
						this.refs.publicRequiredBox.checked = true;
					}
				});
			} else {
				this.setState({
					min: "0"
				}, () => {
					intMin = 0;
					if (intMax === 1) {
						this.setState({
							defaultPublicCheck : true,
							showPreviewQtyBox: false,
							required: false
						});
						this.refs.publicRequiredBox.checked = false;
					} else if (intMax === "" || intMax > intMin) {
						this.setState({
							defaultPublicCheck : false,
							showPreviewQtyBox: true,
							required: false
						});
						this.refs.publicRequiredBox.checked = false;
					} else {
						this.setState({
							defaultPublicCheck : false,
							showPreviewQtyBox: false,
							required: false
						});
						this.refs.publicRequiredBox.checked = false;
					}
				})
			}
		});
	}

	componentDidUpdate(prevProps) {
		if (this.props.reqState && !prevProps.reqState && parseInt(this.state.min) == 0) {
			this.setState({
				min: "1"
			});
		}

		if (prevProps != this.props && !this.props.data.options.length) {
			this.setState({variationsLabel: ""});
		}
	}

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		let {
			hint,
			required,
			label,
			placeholder,
			options,
			optionsLabel,
			cost,
			stock
		} = this.props.data;

		let imageUrl = this.state.imageUrl;
		let imageAlt = this.state.imageAlt || '';
		let showAltTextModal = this.state.showAltTextModal;

		let localization = new Localization(window.edlio.localizations);
		let adaEnabled = parseInt(window.edlio.featureToggle["ada-alt-text-required"]);

		const addVariations = ( options.length === 0 ) ? 'add hint' : 'hidden add hint';
		const displaySelect = (options.length === 0) ? 'hidden variations-container hint' : 'variations-container hint';

		const addImage = ( imageUrl.length === 0 ) ? 'add hint' : 'hidden add hint';

		let publicCheckId = this.props.data.uniqueId + "_public_checkbox";
		let checkboxClasses = "force-require-checkbox";

		return (
			<div className='sale-item-element text input'>
				<div className={"required-additions"}>
					<div className={"quantity-placeholder"} style={{ display: this.state.showPreviewQtyBox ? "block" : "none"}}>
						<label>{localization.localize('Quantity')}</label>
						<input style={{textAlign: 'left'}} type="text" className={"placeholder"} placeholder={this.state.min == this.state.max ? this.state.min : "Qty"} disabled />
					</div>
					<div className={checkboxClasses} style={{ display: this.state.defaultPublicCheck ? "block" : "none"}}>
						<input ref='publicRequiredBox' id={publicCheckId} type='checkbox' defaultChecked={this.state.defaultPublicCheck && this.state.min == "1"} disabled/>
						<label htmlFor={publicCheckId}/>
					</div>
				</div>
				<div className={"image-container"}>
					{imageUrl &&
						<div className="image-holder" style={{ backgroundImage: `url(${imageUrl})` }}>
						<div className="add-alt-btn" onClick={this.addAltText}>
							<SVGIcon
								name="photo_alt"
								color="black"
							/>
						</div>
							<div className="delete-img-btn" onClick={this.removeImage}>
								<SVGIcon
									name="trash"
									color="black"
								/>
							</div>
						</div>
					}
					<div className="uploader-container">
						<div className="delete-img-btn" onClick={this.removeUploader}>
							<SVGIcon name="trash-o" />
						</div>
						<edlio-file-uploader
							className={imageUrl ? 'hidden' : ''}
							ref="uploader"
							url="/apps/api/images/upload"
							fetch-url="/apps/api/images/fetch"
							max-items="1"
							images-only="true"
						/>
					</div>
				</div>
				<div className={"item-info"}>
					<header>
						<InputLabel ref='label' label={localization.localize(label)} required={required} placeholder={placeholder} usePlaceholderLabel={usePlaceholderLabel} />
						<div className={"add-options"}>
							<InputHint ref='hint' className={"hint"} label={localization.localize("Add Description")} hint={hint} placeholder={localization.localize("Description")} />
							<a ref='addImage' className={addImage} href='javascript:;' onClick={this.addImage}>{localization.localize("Add Image")}</a>
							<a ref='addVariations' className={addVariations} href='javascript:;' onClick={this.addVariations}>{localization.localize("Add Variations")}</a>
						</div>
					</header>
					<div className="sale-item-input-container">
						<div className={displaySelect} ref={"variations"}>
								<input
									type="text"
									defaultValue={this.state.variationsLabel}
									placeholder={!this.state.variationsLabel ? localization.localize('Variations Title') : ""}
									onChange={(e) => {
										this.setState({
											variationsLabel: e.target.value
										});
									}}
								/>
								<div className={"select-menu input"}>
									<OptionList
										placeholder={localization.localize('Please Select')}
										initialized={true}
										options={options}
										fieldsetIndex={fieldsetIndex}
										rowIndex={rowIndex}
										index={index}
										isItem={true}
										addOptionCallback={() => {FormActions.addOptionToSelectMenu(fieldsetIndex, rowIndex, index)}}
									/>
								</div>
						</div>
						<div className="inner-row">
							<InputCost
								ref='itemcost'
								includeLabel={false}
								cost={this.state.cost}
								updateCost={this.updateCost}
							/>
							<span>{localization.localize('Price')}</span>
						</div>
						<div className="inner-row">
							<span>{localization.localize('Purchase between min')}</span>
							<input
								className="small-number-box"
								type="number"
								ref={"minquantity"}
								placeholder={"0"}
								value={this.state.min}
								onKeyPress={this.handleKeyPress}
								onChange={(e) => {this.handleBoundsChange(e.target.value, "min")}}
								onBlur={(e) => {this.handleBoundsBlur(e.target.value, "min")}}
							/>
							<span>{localization.localize('and max')}</span>
							<input
								className="small-number-box"
								type="number"
								ref={"maxquantity"}
								placeholder={localization.localize('any')}
								value={this.state.max}
								onKeyPress={this.handleKeyPress}
								onChange={(e) => {this.handleBoundsChange(e.target.value, "max")}}
								onBlur={(e) => {this.handleBoundsBlur(e.target.value, "max")}}
							/>
							<span>{localization.localize('of')}</span>
							<input
								className="small-number-box stock-box"
								type="number"
								ref={"stock"}
								value={(this.state.stock === -1 || this.state.stock === undefined) ? '' : this.state.stock}
								placeholder={localization.localize("unlimited")}
								onKeyPress={this.handleKeyPress}
								onChange={(e) => {this.updateStock(e.target.value)}}
							/>
							<span>{localization.localize('available')}</span>
						</div>
					</div>
				</div>
				{
					imageUrl
					&&
					<div className={"image-preview " + (adaEnabled && imageUrl.length && !imageAlt.length ? 'ada-warning missing-alt-text' : '')}>
						<img src={imageUrl} alt={imageAlt}/>
					</div>
				}
				<div className={"item-info-preview"}>
					<div className={"item-label-preview"}>{label}{this.state.required && <em className={"required-indicator"}>*</em>}</div>
					<div>{hint}</div>
					{
					optionsLabel != ""
					&&
					<div className={"variations-label-preview"}>
						{optionsLabel}:
						<div className={"placeholder"} style={{width: '9em'}}>
							{localization.localize('Please Select')}
							<SVGIcon name='caret-down' />
						</div>
					</div>
					}
					<div className={"price-preview"}>
						<span>Price: ${formatValueToLocale(cost)}</span>
						{
						Number.isInteger(stock)
						&&
						<span className={stock <= 5 ? "stock-preview low-stock" : "stock-preview"}>
							{stock <=5 ?
								<SVGIcon color="peru" name='exclamation-triangle' />
								:
								<SVGIcon color="dimgray" name='info-circle' />
							}
							<span>{stock} {localization.localize('remaining')}</span>
						</span>
						}
					</div>
				</div>
				{
					showAltTextModal
					&&
					<ModalWindowComponent
							title={"Alternate Text"}
							hideCallback={this.hideModal}
					>
							{
								<div className="alt-text-page">
									<div className="page">
										<input type="text" id="alternate-text-container" placeholder={localization.localize('Alternate text for the image')} defaultValue={imageAlt} />
									</div>
									<footer>
										<a className="secondary button"
											onClick={this.hideModal}
											>
											{localization.localize('Cancel')}
										</a>
										<a className="button"
											onClick={this.saveAltText}
										  >
											{localization.localize('Save')}
										</a>
									</footer>
								</div>
							}
					</ModalWindowComponent>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/sale-item.js